import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/ask-reli")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: ({ deps }) => {
    throw redirect({
      to: "/",
      search: deps.externalCustomerId
        ? { askReli: true, externalCustomerId: deps.externalCustomerId }
        : { askReli: true },
    });
  },
});
